import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import logo from '../logo.svg';





function Home() {
  const history = useHistory();
  // const onSubmit = e => {
  //   writeComment(name, input);
  //   setInput('');
  //   setName('');
  // }

  


  // const onFinish = onSubmit;
  return (
    <>
      <h3 class="nanummyeongjo w700" style={{textAlign:"center", marginTop:40}}><b>지구인을 위한 질병관리본부</b></h3>
      <p class="nanummyeongjo" style={{textAlign:"right", marginTop:30}}>글. 임정서</p>
      <p class="nanummyeongjo docs-normal">
      인디아트홀 공은 2014년부터 매년 여름 공포전을 해왔다. 공포 기획전은 조장된 사회에 대한 공포를 예술로 들춰내고, 객관화 시켜 바라보고자 매년 다른 공포를 주제로 진행되었다. 2020년 7번째 공포전은 “질병"을 주제로 생체실험실과 웍밴드공이 기획 협업으로 새로운 창작 실험 형식의 ‘지구인을 위한 질병관리본부' 프로젝트를 시도한다.
      </p>
      <p class="nanummyeongjo docs-normal">
      21세기 현재, 우리는 위생 및 보건이 강화된 현대사회에서 질병으로부터 안전함을 보장받는 듯 살고 있다. 불과 1년 전인 공포전2020년의 주제를 “질병"을 설정하고 저 문장을 썼던 2019년에만 해도 그랬다. 적어도 그렇게 생각했다. 과연 우리 중 누가, 2020년 팬데믹에 이르는 코로나19 감염병의 창궐을 전 지구인이 마주하리라 감히 상상이라도 해봤을까? 
      </p>
      <p class="nanummyeongjo docs-normal">
      물론 과학자들은 감염병의 위기를 예측하고 경고해왔지만, 우리는 열심히 먹고 사느라 바빠 이 경고를 못 보고 못 들은 것은 아닐까? 본 프로젝트의 초기 기획 단계에서는, 이런 재난 수준까지도 갈 수 있는 질병과 보건 위생의 위기(공포)를 예술로 비춰보고, ‘질병’을 다루는 사회의 다양한 이해관계자와 구조를 살펴볼 수 있도록 프로젝트 구성했다. 2019년에 말이다.
      </p>
      <p class="nanummyeongjo docs-normal">
      그런데 웬걸! <br></br>2020년, 기획팀은 우리 앞으로 예측불가하게 펼쳐지던 우한 폐렴이 코로나19로 명명되고 중국과 한국, 그리고 유럽을 휩쓸더니, 전 세계로 퍼지며 WHO가 팬데믹 선언까지 내리는 이 상황을 보며, 멍석이라도 깔아야 하나 싶었다.
      </p>
      <p class="nanummyeongjo docs-normal">
      아래는 내가 2019년 말쯤 참여 예술가에게 보낸 본 프로젝트 제안서이다.
      </p>

      <div style={{
        width: "calc(100% - 30px)",
        marginLeft: 30,
        marginTop: 30,
        border: "1px solid"
      }} class="docs-italic">
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-right docs-italic">
          (2019년 가을 작성)
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          프로젝트 참여 제안서
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          프로젝트명
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0, marginBottom:0}}>
          1안 - 생체실험실: 외계인을 위한 질병관리본부
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          2안 - 생체실험실: 지구인을 위한 질병관리본부
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          프로젝트 개요
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          21세기 현재, 우리는 위생 및 보건이 강화된 현대사회에서 질병으로부터 안전함을 보장받는 듯 살고 있다. 그러나 메르스, 아프리카 돼지 열병, 보건 및 위생에 대한 불안감을 조장해 상업적 이득을 보는 의료 업계, 정보 과다로 되려 신빙성과 신뢰를 잃어버린 의학 정보, 새롭게 발견되는 질병 등 건강 걱정에서부터 온전히 자유로워지진 않았다. 혐오의 대상으로 존재하던 질병에서 터부시 되어 굳이 드러내지 않으려고 하는 정신병까지 역사와 시간 속 다양한 질병에 대한 인식과 사회적 구조를 디자이너, 연극, 시각, 설치, 무용, 음악 분야 예술가들과 함께 들여다보고자 한다.
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          프로젝트 진행 방식
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          본 프로젝트의 창작 과정은 연구소의 실험 방식을 모방하며, 가상의 ‘질병관리본부'가 된다. 기획자와 작가는 질병관리본부의 연구원이 되어, 해당 질병에 관한 작품을 창작한다.
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          기획자는 수석 연구원으로
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          역사 속 세상을 바꾼 질병, 최근 국내에서 가장 큰 논란이 된 감염병 호흡기질환, 사회적으로 인식 개선이 되고 있는 정신병, 의학 기술의 발전으로 죽는 병에서 살 수 있는 병이 된 HIV+(에이즈) 등 몇 가지 질병과 인류 역사의 관계를 살펴볼 수 있는 질병을 토대로 창작 키워드가 담긴 창작 지령을 만든다.
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          참여 작가는 책임 연구원으로
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          제안된 창작 지령을 토대로, 관객이 해당 질병 또는 본인에게 닥친 상황을 마주하는 듯한 공포감을 느낄 수 있는 작품을 창작하거나, 상황을 아울러 이해할 수 있는 예술 작품을 창작한다.
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable-title">
          규칙
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          작가는 연구 지령에 대한 자유로운 주관적 해석과 창의력을 발휘해 지령을 작품화할 수 있다. 지령 설정은 협의를 통해 수정, 변경 또는 조율가능.
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          단, 생체실험실의 기본 룰을 담을 수 있는 방법의 작품을 만드는 것을 목표한다.
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          1. 발표 공간 안 존재하는 창작자 또는 관객이 “행위자"로 역할 할 수 있어야 한다.<br/>
          예) 책임 연구원으로 설정된 작가는 관객 또는 본인을 ‘연구원, 환자’ 등의 역할로 지정한 설정 등
          </p>
          <p class="nanummyeongjo docs-normal docs-indent docs-intable" style={{marginTop:0}}>
          2. 발표 공간 안 존재하는 창작자 또는 관객의, 정신적, 물리적, 정서적 작용을 작품이 보여주거나, 어떠한 기록물로 남아 보일 수 있는 구조여야 한다.
          </p>
      </div>
      
      <p class="nanummyeongjo docs-normal">
      위와 같은 프로젝트 참여 제안서를 받은 참여 예술가들은 함께 “코로나19 사태"로 실제 질병에 대한 공포를 직접 경험으로 겪으며 정말이지 ‘예술 병 연구자’가 된 듯 작업에 임했다. 창작 과정 중 참여 예술가들에게 들은 인상 깊은 코로나19 사태에 반응하던 코멘트를 몇 자 적어본다.
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “초기 단계에서, 다양한 질병을 다루는 다양한 이해관계; 개인, 국가, 컨트롤 타워, 보건 위생 등 다층의 입장에서 바라보는 시각으로 참여 예술가가 프로젝트에 임했으면 했는데, 그 설명과 전달이 어려웠어요. 그런데 코로나19로 질병관리본부, 위기관리, 보건 재난 등을 제가 설명하지 않아도 직접 경험으로 모두가 그냥 살아 이해하는 부분이 생겼어요.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
        임정서, 총괄 기획
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “이게 무슨 일인지 모르겠어요. 내가 19년 가을에 2020년 공포전 주제를 질병으로 잡았는데… 내 스스로가 좀 무서워지네요….”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
        이은정, 기획 자문
      </p>
      
      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “현실에 공포가 있기 때문에, 자칫 주제를 잘 못 다룰까 조심스럽다. 코로나19로 보이는 인간 군상에 대해 초점을 맞춰 작업하고자 한다.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      박철호
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “제 초기 작업 아이디어는 종교를 통해 퍼지는 감염병 확산이었는데... 코로나 상황에 실제로 그런 사건이 일어나서 …. 계획을 바꿔야 할 것 같아요.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      양승욱
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “코로나19 시국과 그에 반응해 나타난 사람들의 이야기를 기록하는 것이 예술가로서 나의 역할이라고 생각한다.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      노경화
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “초기 작업 구상에선, 감자역병을 머리로만 이해해 유희적으로 풀 생각이었는데, 막상 겪어보니 이것은 실재하는 공포고 그걸 가볍게 다룰 수 없는 것이란 걸 직접 경험으로 깨달았다.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      신세빈
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “병균이 전염되고 확산되는 형태가 흥미로워요. 코로나 바이러스가 퍼지고 있는데, 저는 작업으로 감정이나 감각을 확산시키는 시도를 해보고 싶어요. 
      <br/>그 전파력 때문에 차단, 격리가 일상이 된 지금이지만, 그것으로부터 대안적 소통방식을 연구해보고 싶어요.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      임승균
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “저는 지금 대구에서 레지던시를 하면서 대구 신문을 콜라주 작업 소스로 사용해요. 대부분 코로나 기사고, 이를 스크랩하고 기록하는 것이 유의미한 작업이라 생각합니다. 코로나 사태가 앞으로 우리 사회에 어떠한 변화를 가져올지 상상해 봅니다.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      임지혜
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “현실이 더 비현실적인데, 과연 예술로 무엇을 할 수 있을까? 고민됩니다.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      유한솔
      </p>

      <p class="nanummyeongjo docs-normal docs-indent docs-italic">
      “서로에게 sweet 했더라면 인재는 없었을 것' 이라는 작업의 시작이 있었습니다. 하지만 현실은 점점 심각해지고 위기를 겪어보지 않은 자의 풋상상일뿐이라 생각했습니다. 그러던 중 가장 심각한 곳에서 시작 된 선행들에 서로의 따뜻함이 정말 이 시기를 이겨나가고 있다는 걸 느꼈고 가능한 일이라는걸 알았습니다.”
      </p>
      <p class="nanummyeongjo docs-italic docs-comment-author">
      이신아
      </p>

      <p class="nanummyeongjo docs-normal">
      이 코로나19로 인한 보건재난의 공포를 겪은 게 어디 이 프로젝트 팀뿐일까! <br/>
      21세기를 살아가는 지구 전 인류인 걸!
      </p>
      <p class="nanummyeongjo docs-normal">
      인류학 연구에 ‘opportunistic research or emergent sampling (기회주의적 연구나 긴급 샘플링)’이란 분류가 있더라. 여기서 ‘기회주의’는 다소 부정적인 단어의 사회적 의미가 아니라, 현장에서 얻은 경험과 지식을 바탕으로 연구자가 알아가며 (as unfold - 펼쳐내며) 샘플링 결정을 내리는 연구 방법이라고 한다.      </p>
      <p class="nanummyeongjo docs-normal">
      작년부터 시작된 이 ‘예술 병 연구'에도 ‘긴급'을 붙여본다. 예술적 상상보다 더 비현실적인 현실, 팬데믹을 겪으며 느낀 예술가들의 경험과 상상을 풀어낸 ‘지구인을 위한 질병관리본부'로 당신을 초대한다.
      </p>
      <p class="nanummyeongjo docs-normal">
      팬데믹을 함께 살아낸 당신은, ‘지구인을 위한 질병관리본부'를 보고, 과연 어떤 코멘트를 남기고 싶은가?
      </p>
      
      <p onClick={() => {history.push("/")}} class="nanummyeongjo docs-normal docs-indent docs-italic grey-bg" style={{width: "80%"}}>
        <span> &nbsp; </span>
      </p>
      
      <p class="nanummyeongjo docs-italic docs-comment-author">
      <span class="grey-bg">당신, 관객</span>
      </p>
      
    </>
  );
}

export default Home;
